export default __webpack_public_path__ + "static/media/my-man.0793b8e2.gif";